<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div class="modal-mask" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop>
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="modal_reps_to_review d-none-">
                <div class="row mb-2 mt-3">
                  <div class="col-8 pl-4">
                    <div class="h3 d-inline mr-2 text-uppercase">{{ assessment_title }}</div>
                  </div>
                </div>
                <div v-show="loading" class="loading_show">
                  <div class="spinner-border text-danger"></div>
                </div>

                <div class="preview-section">
                  <div class="col-12 p-0 text-align-center" >
                    <div class="landing-page-content" style="padding-left:5px; padding-right:5px; text-align: left;">
                      <span v-html="landingPageContent"></span>
                    </div>
                  </div>
                  <div class="col-lg-12 padding-lr-5  text-align-center" style="padding-right: 0;">
                    <button
                      v-on:click="openAssessmentQuestionPage()"
                      class="btn btn-info btn-md font-weight-bold rounded-pill px-5 ma-blue-btn">Begin Assessment</button>
                  </div>
                  <div style="clear: both; margin-bottom: 25px;"></div>

                
                </div>








              </div>
            </div>

            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>




  </div>
</template>

<script>
import axios from 'axios';


export default {
  props: ['isModalVisible'],
  data() {
    return {
      menteeFirstName: '',
      menteeShortName: '',
      assessmentId: '',
      assessmentAttemptId: '',
      landingPageContent: '',
      assessment_title: '',
      loading: false,
    }
  },
  computed: {
    
  },
  methods: {
    hide() {
      this.$emit('closeAssessmentLandingModal');
    },
    openAssessmentQuestionPage() {
      this.$emit('openAssessmentQuestionModal', this.assessmentId, this.assessmentAttemptId);
    },
    getLandingPageContent(assessmentId, assessmentAttemptId) {

      this.assessmentId = assessmentId;
      this.assessmentAttemptId = assessmentAttemptId;
      axios.get('/assessment-landing-page/' + this.assessmentId, {
      })
      .then(resp =>  {
        this.landingPageContent = resp.data.landingPageContent;
        this.assessment_title = resp.data.assessmentTitle;
      })
      .catch(function(error) {
        console.log(error);
      });


    }

  },

  components: {

  },
  created() {

  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}


::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;    
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/mentee/mentee_assessment_landing_new.vue